import type { SVGProps } from 'react';

const SvgSidebarBelow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#sidebar_below_svg__a)">
      <path
        fill="currentcolor"
        d="M18 5.03H6c-1.65 0-3 1.35-3 3v8c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3v-8c0-1.65-1.35-3-3-3m-12 2h12c.55 0 1 .45 1 1v6H5v-6c0-.55.45-1 1-1"
      />
    </g>
    <defs>
      <clipPath id="sidebar_below_svg__a">
        <path fill="#fff" d="M3 5.03h18v14H3z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSidebarBelow;
